import app from './app';
import github from './github';
import user from './user';

export default {
  ...app,
  ...github,
  ...user,
};



// WEBPACK FOOTER //
// ./scripts/reducers/index.js